import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";

import LoadingModal from "../../loader/LoadingModal";
import Notification from "../other/Notification";

const VarUpdates = () => {
    const navigate = useNavigate();

    const [token, setToken] = useState("");
    const [toggleSideBar, setToggleSideBar] = useState(false);
    const [canvas, setCanvas] = useState(false);


    const [isLoading, setIsLoading] = useState(false);


    const handleToggleSidebar = (e) => {
        e.preventDefault();
        setToggleSideBar(!toggleSideBar);
    };

    const handleToggleOffCanvas = (e) => {
        e.preventDefault();
        setCanvas(!canvas);

    };





    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/auth");
        }
    }, [navigate]);

    useEffect(() => {
        setToken(localStorage.getItem("token"));
        // console.log(toggleSideBar)
    }, [token]);




    const [fullScreenImageShow, setFullScreenImageShow] = useState(false);
    const [fullScreenImageName, setFullScreenImageName] = useState("");
    const [fullScreenImageHederName, setFullScreenImageHederName] = useState("");





    return (
        <>
            {token && (
                <>
                    <div
                        className={
                            toggleSideBar
                                ? "container-scroller sidebar-icon-only"
                                : "container-scroller"
                        }
                    >
                        <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
                            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                                    {/* <img src="images/mini-kr-logo.svg" alt="logo" /> */}
                                </Link>
                                <div className="me-1">
                                    <button
                                        className={
                                            toggleSideBar
                                                ? "navbar-toggler navbar-toggler align-self-center"
                                                : "navbar-toggler navbar-toggler align-self-center text-white"
                                        }
                                        type="button"
                                        onClick={handleToggleSidebar}
                                    >
                                        <span className="icon-menu"></span>
                                    </button>
                                </div>
                                <div>
                                    <Link to="/fooders_cp">
                                        <span className="navbar-brand brand-logo">
                                            <img src="images/vyfoo_logo.png" alt="logo" />
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
                        </nav>
                        <div className="container-fluid page-body-wrapper px-0">
                            <SideBar active="update" toggleCanvas={toggleSideBar} />

                            <div className="main-panel">
                                <div className="content-wrapper">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <h3 className="ukhd mb-3">System Updates</h3>
                                            <div className="row flex-grow">
                                                <div className="col-12 grid-margin">

                                                    {/*Version 1.0.0<*/}
                                                    <div className={'my-2'}>
                                                        <div className="card card-rounded">
                                                            <div className="card-body trcnt">
                                                                <div className="row">

                                                                    <div className="col-12 d-flex justify-content-between">
                                                                        <div className="col-12">
                                                                            <h6 className="update-ver-color"><b>Version 1.0.2 - Release Notes</b></h6>
                                                                            <h6> <b>Date: 31 Mar 2026 </b></h6>
                                                                            <h5><b> What's New</b></h5>

                                                                            <ul className="kr-none">
                                                                                <li className="kr-none">
                                                                                    <b>Fooders staff</b>
                                                                                    <br />
                                                                                    Waiters and cashiers can assign tables.

                                                                                </li>
                                                                                <li className="kr-none">
                                                                                    <b>Local Pos</b>
                                                                                    <br />
                                                                                    Local Pos Live
                                                                                </li>
                                                                                
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/*Version 1.0.0<*/}
                                                    <div className={'my-2'}>
                                                        <div className="card card-rounded">
                                                            <div className="card-body trcnt">
                                                                <div className="row">

                                                                    <div className="col-12 d-flex justify-content-between">
                                                                        <div className="col-12">
                                                                            <h6 className="update-ver-color"><b>Version 1.0.1 - Release Notes</b></h6>
                                                                            <h6> <b>Date: 8 Jan 2026 </b></h6>
                                                                          
                                                                            <ul className="kr-none">
                                                                                <li className="kr-none">
                                                                                    <b>OSDS Panel Launched</b>
                                                                                    <br />
                                                                                    The complete OSDS Panel Is now live and fully operational for day-to-day use.
                                                                                </li>
                                                                                <li className="kr-none">
                                                                                    <b>Fooders Dashboard</b>
                                                                                    <br />
                                                                                    Fooders Dashboard module has been introduced and is now active.
                                                                                </li>
                                                                                <li className="kr-none">
                                                                                    <b>Switch Tables</b>
                                                                                    <br />
                                                                                    After bill generated staff can Switch Tables.
                                                                                </li>
                                                                                 <li className="kr-none">
                                                                                    <b>Payment Qr-code on bill</b>
                                                                                    <br />
                                                                                    Show/Hide Payment QR Code on Bill Print (Business Settings)
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={'my-2'}>
                                                        <div className="card card-rounded">
                                                            <div className="card-body trcnt">
                                                                <div className="row">

                                                                    <div className="col-12 d-flex justify-content-between">
                                                                        <div className="col-12">
                                                                            <h6 className="update-ver-color"><b>Version 1.0.0 - Release Notes</b></h6>
                                                                            <h6> <b>Date: 1 Dec 2025 </b></h6>

                                                                            <ul className="kr-none">
                                                                                <li className="kr-none">
                                                                                    <b>Staff Panel Launched</b>
                                                                                    <br />
                                                                                    The complete Staff Panel Is now live and fully operational for day-to-day use.
                                                                                </li>
                                                                                <li className="kr-none">
                                                                                    <b>NC Report Feature Added</b>
                                                                                    <br />
                                                                                    A brand-new NC (No-Charge) Report module has been introduced and is now active.
                                                                                </li>

                                                                                <li className="kr-none">
                                                                                    <b> Staff Orders Report Feature Added</b>
                                                                                    <br />
                                                                                    A Staff Orders Report   module has been introduced and is now active.
                                                                                </li>
                                                                            </ul>

                                                                            <h6> <b>Date: 22 Dec 2025 </b></h6>


                                                                            <ul className="kr-none">


                                                                                <li className="kr-none">
                                                                                    <b>Hold Order Reports</b>
                                                                                    <br />
                                                                                    A Hold Order Reports   module has been introduced and is now active.
                                                                                </li>
                                                                                <li className="kr-none">
                                                                                    <b>  Enable/Disable staff settled/unsettled amounts</b>
                                                                                    <br />
                                                                                    Implemented a show/hide option for Settled and Unsettled amounts in Business Settings.
                                                                                </li>
                                                                                <li className="kr-none">
                                                                                    <b>  Enable/Disable staff Cashier Report</b>
                                                                                    <br />
                                                                                    Implemented an enable/disable option for the Cashier Report in Business Settings.
                                                                                </li>
                                                                            </ul>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>




                        <div
                            className={fullScreenImageShow ? "modal fade show d-block" : "modal fade"}
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"

                        >

                            <div className="modal-dialog   " role="document" style={{ height: "50vh", minWidth: "70vw" }} >


                                <div className="modal-content w-85" >
                                    <div className="modal-header py-2">
                                        <h5 className="modal-title" id="exampleModalLabel">
                                            {fullScreenImageHederName}

                                        </h5>

                                        <button
                                            type="button"
                                            className="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                            onClick={() => { setFullScreenImageShow(false) }}
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body py-2" >



                                        <div className="container-fluid">
                                            <form className="forms-sample">
                                                <div className="row">
                                                    <h4>{fullScreenImageHederName || "Feature Preview"}</h4>
                                                    <img src={fullScreenImageName} alt={fullScreenImageHederName || "Feature Preview Image"} />
                                                </div>
                                            </form>
                                        </div>

                                    </div>





                                    <div className="modal-footer py-1">








                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            data-dismiss="modal"
                                            onClick={() => { setFullScreenImageShow(false) }}
                                        >
                                            Cancel
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <LoadingModal isLoading={isLoading} />

                    <Notification />
                </>
            )}
        </>
    );
};

export default VarUpdates;